import { createContext } from 'react';

/**
 * Where the voice notes below this point live - a chat, a task discussion, the
 * external portal - so the floating player (VoiceMiniPlayer) can say which one
 * is playing and take you back to it after you have gone somewhere else.
 *
 *   { title, href, jumpState?: (messageId) => object }
 *
 * `jumpState` builds the router state that opens the page at the message;
 * without it the link opens the page and stops there.
 */
const VoiceOriginContext = createContext(null);

export default VoiceOriginContext;
